export enum LocalesEndpoints {
  LANGUAGES = '/languages',
}

export enum SupportedLocales {
  UK = 'uk',
  RU = 'ru',
}

export const DEFAULT_LOCALE = SupportedLocales.UK;

export const getLocaleDisplayLabel = (locale: string): string =>
  locale === SupportedLocales.UK ? 'UA' : locale.toUpperCase();

export interface Locales {
  key: SupportedLocales;
}

// ============== Response ==============

export interface ILanguagesResponse {
  data: {
    languages: SupportedLocales[];
  };
}
